export class LeadDatails {
    LeadID: number;
    LeadName: string;
    OpportunityName: string;
    IsActive: boolean = true;
}